import React from "react";
import { Modal, List, Avatar, Tag, Typography } from "antd";
import { ScheduleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

const { Text } = Typography;

export default function PendingApprovalsModal({
  open,
  onClose,
  data = [],
  employees
}) {
  const navigate = useNavigate();

  const employeeMap = React.useMemo(() => {
  const map = {};
  (employees || []).forEach((emp) => {
    map[emp.id] = emp.user_name;
  });
  return map;
}, [employees]);
  

  return (
    <Modal
      title="Pending Attendance Approvals"
      open={open}
      onCancel={onClose}
      footer={null}
      width={500}
      styles={{
        body: {
          maxHeight: "60vh",
          overflowY: "auto",
        },
      }}
    >
      {data.length ? (
        <List
          dataSource={data}
          renderItem={(item) => (
            <List.Item
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/hrpayroll/attendance?approve")}
            >
              <List.Item.Meta
                avatar={<Avatar icon={<ScheduleOutlined />} />}
                title={<Text strong>{employeeMap[item.emp_id] || item.emp_id}</Text>}
                description={
                  <>
                    <div>
                      Date:{" "}
                      {dayjs(item.attendance_date).format("DD-MM-YYYY")}
                    </div>
                    <div>Type: {item.attendance}</div>
                    <div>Check-in: {item.check_in} | Check-out: {item.check_out}</div>

                    <div>
                      Status:{" "}
                      <Tag color="red">
                        Attendance awaiting approval
                      </Tag>
                    </div>
                  </>
                }
              />
            </List.Item>
          )}
        />
      ) : (
        <div style={{ textAlign: "center", padding: 20 }}>
          <Text type="secondary">No pending approvals 🎉</Text>
        </div>
      )}
    </Modal>
  );
}